import type { PaymentsQueryParams } from 'lib/navigation/hooks/usePaymentsNavigation/helpers/getPaymentsQueryParams/getPaymentsQueryParams'
import { ReconciliationItemTypeEnum } from 'gql/types'

export enum RouterPage {
  root = '/',
  login = '/login',
  loginSetup = '/login-setup',
  loginVerify = '/login-verify',
  dashboard = '/dashboard',
  inbox = '/inbox',
  clientManager = '/client-manager',
  docsAndReports = '/docs-and-reports',
  insights = '/insights',
  payables = '/bills',
  receivables = '/receivables',
  purchasers = '/purchasers',
  payments = '/payments',
  receipts = '/receipts',
  catalog = '/catalog',
  vendors = '/vendors',
  purchaseOrders = '/purchase-orders',
  workOrders = '/work-orders',
  error = '/error',
  verifyEmail = '/verify-email',
  acceptTos = '/accept-terms-of-service',
  forgotPassword = '/forgot-password',
  syncCenter = '/sync-center',
  termsOfService = '/terms-of-service',
  deferralTermsAndConditions = '/deferral-terms-and-conditions',
  referralTermsAndConditions = '/referral-terms-and-conditions',
  unsupported = '/unsupported',
  matching = '/matching',
  salesOrders = '/sales-orders',
  locations = '/locations',
  renewSubscription = '/renew-subscription',
  submitTaxForm = '/submit-tax-form',
  workingCapitalOnboarding = '/onboarding/working-capital',
  tally = '/tally',
}

export enum BusinessFormAnchor {
  taxForm = 'business-tax-form',
  logoUpload = 'logo-upload',
  businessName = 'business-name',
  stateOfFormation = 'state-of-formation',
  businessStructure = 'business-structure',
  businessStructureTaxClassification = 'business-structure-tax-classification',
  doingBizAs = 'doing-biz-as',
  einTin = 'business-details-form_ein-tin_input',
  website = 'website',
  country = 'country',
  industry = 'industry',
  address = 'address',
  mailingAddress = 'mailingAddress',
}

export enum SecurityFormAnchor {
  teamSecurity = 'mfa-enforcement-level-section',
}

export type VendorOnboardingPage =
  | 'business-details'
  | 'upload-tax-form'
  | 'link-bank-accounts'
  | 'verify-vendor-international'
  | 'verification-deposits'
  | 'verification-failed'
  | 'verify-vendor-plaid'
  | 'verify-vendor-manually'
  | 'complete-verification'

export const GUIDED_BILL_EXPERIENCE_QUERY_PARAM = 'guided_bill_exp'
export const GUIDED_PO_EXPERIENCE_QUERY_PARAM = 'guided_po_exp'
export const FOCUSED_LINE_ITEM_ID_QUERY_PARAM = 'focused_line_item_id'
// Temporary discriminator: present alongside `invoice_id` to route the URL to
// the new InvoiceDetailsDialog instead of the legacy bill dialog's `invoice_id` fallback.
// Remove once the legacy `invoice_id` fallback is retired https://linear.app/settle/issue/STL-2825/remove-new-invoice-query-param
export const NEW_INVOICE_QUERY_PARAM = 'new_invoice'

export const queryActions = {
  approveDebit: 'approve_debit',
  extend: 'extend',
  approve: 'approve',
  disapprove: 'disapprove',
  approveInvoice: 'approve_invoice',
  rejectInvoice: 'reject_invoice',
  factor: 'factor',
  /**
   * Opens the comment section for a specified document.
   */
  docComment: 'doc_comment',
  /**
   * Triggers the request to authorize the sync with Finaloop.
   */
  requestFinancialsSync: 'request_financials_sync',
} as const

export const FAILED_REPAYMENTS_NAVIGATION_PARAMS = {
  group: 'failed',
  filters: {
    item_type: [ReconciliationItemTypeEnum.EPT_REPAYMENT, ReconciliationItemTypeEnum.AMORTIZED_INSTALLMENT]
      .map((type) => type.toLowerCase())
      .join(','),
  },
} satisfies PaymentsQueryParams

export const PAYMENT_NAVIGATION_QUERY_PARAMS = [
  'transfer_id',
  'reconciliation_item_id',
  'ext_period',
  'offer_id',
  'auto_focus',
] as const
